import { render } from "./Toolbar.vue?vue&type=template&id=1dfcc894"
import script from "./Toolbar.vue?vue&type=script&lang=js"
export * from "./Toolbar.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/bezbedno/admin/static/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"js/Components/Toolbar/Toolbar.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "1dfcc894"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('1dfcc894', __exports__)) {
    console.log('reload')
    api.reload('1dfcc894', __exports__)
  }
  
  module.hot.accept("./Toolbar.vue?vue&type=template&id=1dfcc894", () => {
    console.log('re-render')
    api.rerender('1dfcc894', render)
  })

}


export default __exports__